// Documentation structure and navigation configuration
export const docStructure = [
  {
    category: 'Introduction',
    icon: 'fa-home',
    items: [
      { id: 'overview', title: 'Overview' },
      {
        id: 'api-reference',
        title: 'API Reference',
        children: [
          { id: 'memory-apis', title: 'Memory APIs', icon: 'fa-database' },
          { id: 'response-apis', title: 'Response APIs', icon: 'fa-comments' },
        ]
      },
      { id: 'faq', title: 'FAQ' }
    ]
  },
  {
    category: 'Concepts',
    icon: 'fa-lightbulb',
    items: [
      { id: 'memory-types', title: 'Memory Types' },
      {
        id: 'memory-operations',
        title: 'Memory Operations',
        children: [
          { id: 'add-memory', title: 'Add Memory', icon: 'fa-plus' },
          { id: 'retrieve-memory', title: 'Retrieve Memory', icon: 'fa-search' }
        ]
      }
    ]
  },
  // {
  //   category: 'API Reference',
  //   icon: 'fa-code',
  //   items: [
  //     {
  //       id: 'memory-apis',
  //       title: 'Memory APIs',
  //       children: [
  //         { id: 'memorize-conversation', title: 'Memorize Conversation', icon: 'fa-plus' }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   category: 'API Reference',
  //   icon: 'fa-code',
  //   items: [
  //     {
  //       id: 'memory-apis',
  //       title: 'Memory APIs'
  //       // children: [
  //       //   { id: 'memorize-conversation', title: 'Memorize Conversation', icon: 'fa-plus' },
  //       //   { id: 'get-task-status', title: 'Get Task Status', icon: 'fa-clock' },
  //       //   { id: 'retrieve-default-categories', title: 'Retrieve Default Categories', icon: 'fa-list' },
  //       //   { id: 'retrieve-related-memory-items', title: 'Retrieve Related Memory Items', icon: 'fa-search' },
  //       //   { id: 'retrieve-related-clustered-categories', title: 'Retrieve Related Clustered Categories', icon: 'fa-layer-group' },
  //       //   { id: 'delete-memories', title: 'Delete Memories', icon: 'fa-trash' },
  //       //   { id: 'chat', title: 'Memory-Enhanced Chat', icon: 'fa-comments' }
  //       // ]
  //     },
  //     {
  //       id: 'response-apis',
  //       title: 'Response APIs'
  //     }
  //   ]
  // },
  {
    category: 'Getting Started',
    icon: 'fa-rocket',
    items: [
      { id: 'cloud-version', title: 'Cloud Version' },
      { id: 'enterprise-edition', title: 'Enterprise Edition' },
      { id: 'self-hosting', title: 'Self-Hosting' }
    ]
  },
  {
    category: 'Usage Guide',
    icon: 'fa-book',
    items: [
      { id: 'use-cases', title: 'Use Cases' }
    ]
  },
  {
    category: 'Compare',
    icon: 'fa-scale-balanced',
    items: [
      { id: 'memu-vs-mem0', title: 'memU vs mem0' }
    ]
  },
  {
    category: 'Community',
    icon: 'fa-users',
    items: [
      { id: 'contributing', title: 'Contributing' }
    ]
  }
];

// Table of contents configuration for each section
export const tocConfig = {
  'overview': [
    { href: '#star-us', title: 'Star Us on GitHub' },
    { href: '#highlights', title: 'Key Highlights' },
    { href: '#community', title: 'Join Community' }
  ],
  'responseapi': [
    { href: '#installation', title: 'Step 1: Installation and Setup' },
    { href: '#api-key-setup', title: 'Step 2: API Key Setup' },
    { href: '#initialize-client', title: 'Step 3: Initialize Client' },
    { href: '#response-api', title: 'Step 4: Response API Solution' },
    { href: '#platform-options', title: 'Platform Options' }
  ],
  'response-api-js': [
    { href: '#installation', title: 'Step 1: Installation and Setup' },
    { href: '#api-key-setup', title: 'Step 2: API Key Setup' },
    { href: '#initialize-client', title: 'Step 3: Initialize Client' },
    { href: '#response-api', title: 'Step 4: Response API Solution' },
    { href: '#platform-options', title: 'Platform Options' }
  ],
  'memory': [
    { href: '#overview', title: 'Overview' },
    { href: '#step-1-installation', title: 'Step 1: Installation and Setup' },
    { href: '#step-2-initialize', title: 'Step 2: Initialize Client' },
    { href: '#step-3-workflow', title: 'Step 3: Memory Workflow' },
    { href: '#step-4-retrieve-memories', title: 'Step 4: Retrieve Memories' },
    { href: '#step-5-build-context', title: 'Step 5: Build Context' },
    { href: '#step-6-ai-interaction', title: 'Step 6: AI Interaction' },
    { href: '#step-7-memorize', title: 'Step 7: Save Conversation' },
    { href: '#step-8-complete-example', title: 'Step 8: Complete Example' },
    { href: '#best-practices', title: 'Best Practices' },
    { href: '#integration-examples', title: 'Framework Integration' },
    { href: '#comparison', title: 'API Comparison' }
  ],
  'memory-api-js': [
    { href: '#overview', title: 'Overview' },
    { href: '#step-1-installation', title: 'Step 1: Installation and Setup' },
    { href: '#step-2-initialize', title: 'Step 2: Initialize Client' },
    { href: '#step-3-workflow', title: 'Step 3: Memory Workflow' },
    { href: '#step-4-retrieve-memories', title: 'Step 4: Retrieve Memories' },
    { href: '#step-5-build-context', title: 'Step 5: Build Context' },
    { href: '#step-6-ai-interaction', title: 'Step 6: AI Interaction' },
    { href: '#step-7-memorize', title: 'Step 7: Save Conversation' },
    { href: '#step-8-complete-example', title: 'Step 8: Complete Example' },
    { href: '#best-practices', title: 'Best Practices' },
    { href: '#integration-examples', title: 'Framework Integration' },
    { href: '#comparison', title: 'API Comparison' }
  ],
  'faq': [
    { href: '#general-questions', title: 'General Questions' },
    { href: '#technical-questions', title: 'Technical Questions' },
    { href: '#implementation-questions', title: 'Implementation Questions' },
    { href: '#use-cases-applications', title: 'Use Cases & Applications' },
    { href: '#cost-performance', title: 'Cost & Performance' },
    { href: '#getting-help', title: 'Getting Help' }
  ],
  'cloud-version': [
    { href: '#instant-access', title: 'Instant Access' },
    { href: '#step-by-step', title: 'Step-by-step' }
  ],
  'use-cases': [
    { href: '#ai-education', title: 'AI Education' },
    { href: '#ai-therapy', title: 'AI Therapy' },
    { href: '#implementation-examples', title: 'Implementation Examples' },
    { href: '#ai-education-example', title: 'AI Education Code' },
    { href: '#ai-therapy-example', title: 'AI Therapy Code' }
  ],
  'memory-types': [
    { href: '#overview', title: 'Overview' },
    { href: '#memory-units', title: 'Memory Units' },
    { href: '#memory-categories', title: 'Memory Categories' }
  ],
   'memory-operations': [
     { href: '#overview', title: 'Overview' },
     { href: '#getting-started', title: 'Getting Started' },
     { href: '#workflow', title: 'Typical Workflow' },
     { href: '#quick-reference', title: 'Quick Reference' }
   ],
     'add-memory': [
       { href: '#overview', title: 'Overview' },
       { href: '#memory-workflow', title: 'Memory Processing Workflow' },
       { href: '#basic-creation', title: 'Basic Creation' }
     ],
    'retrieve-memory': [
      { href: '#overview', title: 'Overview' },
      { href: '#retrieval-methods', title: 'Retrieval Methods' },
      { href: '#use-cases', title: 'Example Use Cases' }
    ],
    'memory-apis': [
      { href: '#endpoints-overview', title: 'Endpoints Overview' },
      { href: '#authentication', title: 'Authentication' },
      { href: '#base-url', title: 'Base URL' },
      { href: '#memorize-conversation', title: 'Memorize Conversation' },
      { href: '#get-task-status', title: 'Get Memorization Task Status' },
      { href: '#delete-memory', title: 'Delete Memories' },
      { href: '#retrieve-categories', title: 'Retrieve Default Categories' },
      { href: '#retrieve-related', title: 'Retrieve Related Memory Items' },
      { href: '#error-handling', title: 'Error Handling' }
    ],
    'response-apis': [
      { href: '#authentication', title: 'Authentication' },
      { href: '#base-url', title: 'Base URL' },
      { href: '#chat-response', title: 'Chat Response' },
      { href: '#streaming-chat', title: 'Streaming Chat' },
      { href: '#conversation-history', title: 'Conversation History' },
      { href: '#delete-conversation', title: 'Delete Conversation' },
      { href: '#error-handling', title: 'Error Handling' },
      { href: '#rate-limits', title: 'Rate Limits' },
      { href: '#available-models', title: 'Available Models and Pricing' },
      { href: '#comparison', title: 'Response API vs Memory API' }
  ],
  'memu-vs-mem0': [
    { href: '#overview', title: 'Overview' },
    { href: '#when-to-choose-memu', title: 'When to choose memU' },
    { href: '#when-to-choose-mem0', title: 'When to choose mem0' },
    { href: '#memu-advantages', title: 'memU Advantages' },
    { href: '#feature-comparison', title: 'Feature Comparison' },
    { href: '#pricing', title: 'Pricing' },
    { href: '#open-source', title: 'Open Source' },
    { href: '#get-started', title: 'Get Started' }
  ]
};